import { Fragment, PureComponent, ReactNode } from 'react';

import Button from '@atlaskit/button/standard-button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import Modal, {
  ModalHeader,
  ModalTransition,
  ModalTitle,
  ModalBody,
} from '@atlaskit/modal-dialog';
import { token } from '@atlaskit/tokens';

type RepositoryDetailsModalProps = {
  heading?: ReactNode;
  modalTrigger: (onClick: () => void) => ReactNode;
  modalTriggerCallback?: () => void;
  children: ReactNode;
};

type RepositoryDetailsModalState = { isOpen: boolean };

export default class RepositoryDetailsModal extends PureComponent<
  RepositoryDetailsModalProps,
  RepositoryDetailsModalState
> {
  state = { isOpen: false };

  onOpenClick = () =>
    this.setState({ isOpen: true }, this.props.modalTriggerCallback);
  onCloseClick = () => this.setState({ isOpen: false });

  render() {
    const { isOpen } = this.state;
    const { heading, children, modalTrigger } = this.props;

    const Header = () => (
      <ModalHeader>
        <ModalTitle>{heading}</ModalTitle>
        <Button onClick={this.onCloseClick} appearance="link" spacing="none">
          <CrossIcon
            label="Close Modal"
            primaryColor={token('color.icon')}
            size="medium"
          />
        </Button>
      </ModalHeader>
    );

    return (
      <Fragment>
        {modalTrigger(this.onOpenClick)}

        <ModalTransition>
          {isOpen && (
            <Modal onClose={this.onCloseClick} width="small">
              <Header />
              <ModalBody>{children}</ModalBody>
            </Modal>
          )}
        </ModalTransition>
      </Fragment>
    );
  }
}
